import { CloseSquare, Edit, Edit2, Eye } from "iconsax-react";
import React from "react";
import { MdFileDownload } from "react-icons/md";
import Layout from "../../../components/layout/Layout";
import usePermissionsLogic from "./usePermissionsLogic";
import { Field, Form, Formik } from "formik";
import { Dialog } from "@mui/material";
import { AddCardUser } from "../Users";
import { toast } from "react-toastify";
import useToggleModal from "../../../hooks/utils/useToggleModal";

function Permissions() {
  const { fetchAllPermissions, handleSearchTerm } = usePermissionsLogic();
  const { modalState, toggleModalState } = useToggleModal();
  return (
    <Layout pageName="Users">
      <AddPermissionCard open={modalState} handleClose={toggleModalState} />
      <section className="mt-3">
        <div className="flex items-center justify-between">
          <h2 className="text-[#4E5566] text-lg font-semibold">Permission</h2>
          <button
            className="btn bg-[#4E5566] px-10 text-white"
            onClick={toggleModalState}
          >
            Create Permission
          </button>
        </div>
        <div className="bg-white rounded-md p-3 mt-5">
          <div className="card  bg-white  rounded ">
            <div className="flex items-center justify-between">
              <h4 className="text-sm">Manage Permissions</h4>
              <div className="flex items-center">
                <label className="input input-sm input-bordered flex items-center gap-2 mr-3">
                  <input
                    type="text"
                    className="grow "
                    placeholder="Search Permission"
                    onChange={handleSearchTerm}
                  />
                  <kbd className="kbd kbd-sm">⌘</kbd>
                </label>

                <button className="btn btn-sm btn-outline">
                  <MdFileDownload />{" "}
                </button>
              </div>
            </div>
          </div>

          <div className=" mt-4 bg-white rounded-lg">
            <table className="table">
              <thead className="bg-[#F5F5F5]">
                <tr>
                  <th>No</th>
                  <th>Category</th>
                  <th>Status </th>
                  <th>Date Created</th>
                  <th className="align-middle text-center"> Action</th>
                  <th></th>
                </tr>
              </thead>
              <tbody className="font-xs font-normal">
                {fetchAllPermissions.data?.map((item, index) => (
                  <tr className="font-xs font-normal items-center">
                    <th>{index + 1} </th>

                    <th className="font-xs font-normal capitalize">
                      {item.name}
                    </th>
                    <th className="font-xs font-normal">
                      {item.is_active ? "Active" : "InActive"}
                    </th>
                    <th className="font-xs font-normal">{item.createdAt}</th>
                    <th className="font-xs font-normal ">
                      <div className="flex gap-1 items-center justify-center">
                        <Eye size="16" color="#828A9B" />
                        <Edit size="16" color="#828A9B" />
                        <Edit2 size="16" color="#828A9B" />
                      </div>
                    </th>
                    <th></th>
                  </tr>
                ))}
                {fetchAllPermissions.isLoading && (
                  <div className="  loading loading-spinner"></div>
                )}
              </tbody>
            </table>

            <div className=" flex items-center gap-2 mt-5">
              <div className=" flex items-center gap-1">
                <p className="text-xs font-semibold">Create =</p>{" "}
                <Edit2 size="16" color="#828A9B" />
              </div>
              <div className=" flex items-center gap-1">
                <p className="text-xs font-semibold">Edit =</p>{" "}
                <Edit size="16" color="#828A9B" />
              </div>
              <div className=" flex items-center gap-1">
                <p className="text-xs font-semibold">View =</p>{" "}
                <Eye size="16" color="#828A9B" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}

export default Permissions;

function AddPermissionCard(props: AddCardUser) {
  const { createNewPermissions, fetchAllPermissions } = usePermissionsLogic();
  return (
    <Dialog open={props.open} onClose={props.handleClose}>
      <div className="p-6 w-[300px]">
        <div className=" w-full mb-4 flex items-center justify-between">
          <p className="font-bold text-sm">Add New Permission</p>
          <button onClick={props.handleClose}>
            <CloseSquare size="22" color="#071839" />
          </button>
        </div>

        <Formik
          initialValues={{
            name: "",
          }}
          onSubmit={(values, { setSubmitting }) => {
            setSubmitting(true);
            createNewPermissions.mutate(
              { name: values.name },
              {
                onSuccess: () => {
                  toast.dismiss();
                  toast.success(`Updates Successfuly`);
                  fetchAllPermissions.refetch();
                  props.handleClose();
                },
                onError: (err: any) => {
                  // console.log({ err });
                  toast.dismiss();
                  toast.error(
                    `Unable to create Permission: ` + err?.response.data.message
                  );
                },
                onSettled: () => {
                  setSubmitting(false);
                },
              }
            );
          }}
        >
          {({ isSubmitting }) => (
            <Form>
              <div className="">
                <label className="form-control w-full max-w-xs">
                  <p className="label text-xs text-[#4E5566] font-semibold">
                    Permission Name:
                  </p>
                  <Field
                    required
                    name="name"
                    className="input input-bordered outline-none w-full max-w-xs"
                  />
                </label>
              </div>
              {/* <div className="my-4">
                <label className="form-control w-full max-w-xs">
                  <p className="label text-xs text-[#4E5566] font-semibold">
                    Service Code:
                  </p>
                  <Field
                    required
                    name="serviceCode"
                    className="input input-bordered outline-none w-full max-w-xs"
                  />
                </label>
              </div> */}
              {/* <div className=" mb-3">
                <label className="form-control w-full max-w-xs">
                  <p className="label text-xs text-[#4E5566] font-semibold">
                    Postback Url:
                  </p>
                  <Field
                    required
                    name="post_back_url"
                    className="input input-bordered outline-none w-full max-w-xs"
                  />
                </label>
              </div> */}
              <div className="mx-6 mt-4">
                <button
                  className="btn btn-outlined w-full bg-[#071839ea] text-white hover:bg-[#071839] "
                  type="submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Creating User" : "Save"}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Dialog>
  );
}
